import { createContext } from "react";

export class Stack<T> {
  stack: Array<T> = [];

  get size() {
    return this.stack.length;
  }

  push(item: T) {
    this.stack.push(item);
  }

  pop() {
    return this.stack.pop();
  }
}

export interface StackContextValue<T> {
  stack: Stack<T>;
}

export function createStackContext<T>() {
  return createContext<StackContextValue<T>>({
    stack: new Stack<T>(),
  });
}
